<template lang="pug">
  .dashboard-inner.narrow-modal-body
    SectionTitle(text="Delete payment method" data-mr-ass="delete-payment-modal").app-modal-title
    .prompt Are you sure you want to delete the following payment method?
    .row.payment-profile
      PaymentProfile(:profile="profileToDelete")

    .row
      SubmitButtons(submit-text="Delete" cancel-text="Cancel" :submit-method="onSubmit" :cancel-method="hideModal")

  
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import PaymentProfile from "./PaymentProfile";
  import SubmitButtons from '../SubmitButtons';
  import SectionTitle from "../SectionTitle";

  export default {
    name: "PaymentDeleteModal",
    components: {
      SectionTitle,
      PaymentProfile,
      SubmitButtons
    },

    computed: {
      ...mapState('payments',[
        'profileToDelete'
      ])
    },

    methods: {
      ...mapActions('modal', ['hideModal']),

      onSubmit() {
        this.hideModal();
        this.$store.dispatch('payments/deleteProfile');
      },

      cleanUp() {
        this.$store.commit('payments/clearProfileToDelete');
      },

      beforeDestroy() {
        this.cleanUp();
      }
    }
  }
</script>

<style scoped lang="stylus">
  .payment-profile
    margin 1.5em 0 2em 0
</style>